import { useEffect } from 'react';
import { ChakraProvider, type ChakraProviderProps } from '@chakra-ui/react';
import { ThemeProvider as NextThemeProvider, useTheme as useNextThemes } from 'next-themes';

import { useTheme as useSessionTheme } from '@blockworks/session/theme';

const UiKitProvider = ({ children, value }: ChakraProviderProps) => {
    return (
        <ChakraProvider value={value}>
            <NextThemeProvider attribute="class" disableTransitionOnChange>
                <SyncWithSession />
                {children}
            </NextThemeProvider>
        </ChakraProvider>
    );
};

const SyncWithSession = () => {
    const { themeName: sessionTheme } = useSessionTheme();
    const { setTheme, theme } = useNextThemes();

    useEffect(() => {
        const userTheme = sessionTheme?.toLowerCase();

        if (userTheme !== theme?.toLowerCase() && userTheme) {
            setTheme(userTheme);
        }
    }, [theme, sessionTheme, setTheme]);

    return null;
};

export { UiKitProvider };
